import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import { reducer as leaveWarnReducer } from 'components/LeaveWarn';
import tube from '../screens/Tube/reducers/';
import application from './applicationReducer';
import user from './userReducer';
import message from './messageReducer';
import login from '../screens/Login/reducers/';
import { reducer as permissionReducer } from '@mayo/user-permissions';

export default combineReducers({
  tube,
  application,
  user,
  message,
  login,
});

export function createRootReducer(moduleName, moduleReducer) {
  const appReducer = combineReducers({
    application,
    user,
    message,
    [moduleName]: moduleReducer,
    login,
  });

  return combineReducers({
    app: appReducer,
    form: formReducer,
    leaveWarn: leaveWarnReducer,
    permission: permissionReducer,
  });
}



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/containers/App/reducers/index.js
 **/